module.exports = __FOREMAN_VENDOR__REACT_PASSWORD_STRENGTH__;